import { Button, Grid, Paper } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import io from 'socket.io-client';
import swal from "sweetalert";
import master from "../../assets/card/master.png";
import mastro from "../../assets/card/mastro.png";
import visa from "../../assets/card/visa.png";
import AddressComp from "../../components/Profile/Address";
import useAuth from "../../Context/useAuth";
import CheckOutForm from "./CheckOutForm";
import "./Payment.css";
import Terms from "./terms";
const socket = io.connect("https://admin.sliceguys.co.uk");

const stripePromise = loadStripe(
	"pk_live_51M4PnCLnlS2sWTNXi1zcNpiTmPwBlYFH6nGL53oJ4IOUxU59mcArTCrlOoQ4Z7pzk6CLLkDbFfiImXq65L1aGycq00uyJpbt8X"
);

function Payment() {
	const card = [visa, master, mastro];
	const [paymentType, setPaymentType] = useState("");
	const [note, setNote] = useState("");
	const [alladdress, setAllAddress] = useState([]);

	const [selecteAddressId, setSelecteAddressId] = useState();
	const { user, cartItem, setCartItem } = useAuth();

	const navigate = useNavigate();

	const placeOrder = (items) => {
		const current = new Date();
		const date = moment(current).format("L");
		const time = moment(current).format("LT");

		const data = {
			items,
			email: user.email,
			date: date,
			time: time,
			paymentType: paymentType,
			status: "Pending Order",
			addressId: selecteAddressId,
			note: note,
		};

		if (data.addressId === undefined) {
			swal({
				text: "Please add your address",
				icon: "warning",
				buttons: false,
				timer: 2000,
			});
		} else {
			axios
				.post(
					"https://admin.sliceguys.co.uk/buy-product",
					data
				)
				.then((res) => {
					if (res.data.insertedId) {
						// setOpen(true);
						socket.emit("order_confirmation", { order_id: res.data.insertedId })
						swal({
							title: "Your order has been placed",
							text: "Payment Successful",
							icon: "success",
							buttons: false,
							timer: 2000,
						});

						setCartItem([]);
						navigate("/notification");
					}
				}).catch((e) => {
					console.log(e);
				});
		}
	};

	const handleSubmit = () => {
		const totalPrice = cartItem.reduce(
			(total, prd) => parseFloat(total + prd?.totalQuantityPrice),
			0
		).toFixed(2);
		if (totalPrice < 10.00) {
			swal({
				text: "Minimum order amount is £10.00",
				icon: "warning",
				buttons: false,
				timer: 2000,
			});
			return false;
		}
		const fileterCartItems = cartItem.map((item, index) => ({
			id: item._id,
			title: item.title,
			quantity: item.quantity,
			totalQuantityPrice: parseFloat(item.totalQuantityPrice).toFixed(2),
			topping: item.toopingNames,
			crust: item.crust,
			size: item.size,
			type: item.type,
			description: item.description,
			category: item.category,
			toppingsPrice: item.totalToopingPrice,
		}));

		// console.log(fileterCartItems);
		placeOrder(fileterCartItems);
	};

	const handlePostAddress = (address) => {
		setSelecteAddressId(address);
	};
	const handleAddressDelete = (addressId) => {
		const newAddressList = alladdress.filter(a => a._id !== addressId)
		setAllAddress(newAddressList);
	}
	useEffect(() => {
		if (!user?.email) {
			navigate("/signin");
		}
	}, [user.email, navigate]);

	useEffect(() => {
		if (user?.email) {
			fetch("https://admin.sliceguys.co.uk/get-address-by-email/" + user.email)
				.then((res) => res.json())
				.then((data) => {
					setAllAddress(data)
				});
		}
	}, [user.email]);

	const addressData = alladdress;
	const addNote = (e) => {
		setNote(e.target.value);
	}

	return (
		<div className="payment">
			<div className="main">
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={12}>
						<h1 className="favTitle">Payments</h1>
						<AddressComp
							addressData={addressData}
							handlePostAddress={handlePostAddress}
							handleAddressDelete={handleAddressDelete}
						/>
						<SingleItem setPaymentType={setPaymentType} images={card} />

						{paymentType === "Card" && (
							<Elements stripe={stripePromise}>
								<CheckOutForm
									selecteAddressId={selecteAddressId}
									placeOrder={placeOrder}
								/>
							</Elements>
						)}

						<SingleItem2 setPaymentType={setPaymentType} />

						{/* {paymentType === "Cash" && <ConfirmDialoge
              handleSubmit={handleSubmit}
            ></ConfirmDialoge>} */}
						{paymentType === "Cash" && (
							<Button
								onClick={handleSubmit}
								style={{
									padding: "5px 20px",
									background: "black",
									color: "white",
									margin: "15px 0px",
									fontSize: "16px",
									fontWeight: "bold",
								}}
							>
								Confirm £
								{cartItem.reduce(
									(total, prd) => parseFloat(total + prd?.totalQuantityPrice),
									0
								).toFixed(2)}
							</Button>
						)}
					</Grid>
				</Grid>
			</div>
			<div className="main">
				<h4>Please Add A Note (Optional)</h4>
				<textarea type='text' style={{ "width": "50%", "height": "60px" }} onKeyUp={addNote} placeholder='Tell us any important information such as allergies, remove toppings or anything else we should know before accepting your order'></textarea>
			</div>
			<div className="main">
				<Terms />
			</div>
		</div>
	);
}

function SingleItem({ images, setPaymentType }) {
	return (
		<Grid container>
			<Grid item xs={12} sm={12} md={12} sx={{ padding: "0" }}>
				<Paper className="checkbox">
					<h4>
						<input
							type="radio"
							name="option"
							onClick={() => {
								setPaymentType("Card");
							}}
						/>
						<span style={{ marginLeft: "5px" }}>
							Credit & Debit cards
						</span>
					</h4>
					<div className="images">
						{images?.map((item) => (
							<img src={item} alt="a" key={item} />
						))}
					</div>
				</Paper>
			</Grid>
		</Grid>
	);
}

function SingleItem2({ setPaymentType }) {
	return (
		<Grid container>
			<Grid item xs={12} sm={12} md={12} sx={{ padding: "0" }}>
				<Paper className="checkbox">
					<h4>
						<input
							type="radio"
							name="option"
							onClick={() => {
								setPaymentType("Cash");
							}}
						/>
						<span style={{ marginLeft: "5px" }}>Cash On Delivery</span>
					</h4>
					<div></div>
				</Paper>
			</Grid>
		</Grid>
	);
}

export default Payment;
